export default __webpack_public_path__ + "static/media/laconic_cube@2x.f564be3f.jpg";